import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Select from "react-select";
import { useSelectedProduct } from "../contexts/SelectedProductContext";
import DashboardHelpInfoTab from "./Dashboard-HelpInfo-Tab";
import DashboardExportTab from "./Dashboard-Export-Tab";
import SwitchProducts from "./SwitchProducts";
import envConfig from "../envConfig";
import Product2Map from "./Product2Map";

const LayerGroupSelector = ({ groupLayerOptions = [], layerOptions = [], selectedLayerId, handleLayerChange }) => {
    const [openGroup, setOpenGroup] = useState(null);
    useEffect(() => {
        if (groupLayerOptions.length) {
            let parentGroup = groupLayerOptions.find((g) => g.options.some((o) => o.layer_id == selectedLayerId));
            if (parentGroup) {
                setOpenGroup(parentGroup.group);
            } else if (!openGroup) {
                setOpenGroup(groupLayerOptions[0].group);
            }
        }
    }, [groupLayerOptions, selectedLayerId]);
    const toggleGroup = (g) => setOpenGroup(g);

    return (
        <>
            <div className="pt-2">
                {layerOptions.length && groupLayerOptions.length && groupLayerOptions.map((a) => {
                    const isOpen = openGroup === a.group;
                    return (
                        <div key={a.group} className="mb-3 border-bottom border-0 pb-2">
                            <div className="d-flex align-items-center gap-2">
                                <div className="form-check form-switch m-0 ps-5">
                                    <input
                                        className="form-check-input form-switch"
                                        type="radio"
                                        id={`toggle-${a.group}`}
                                        checked={isOpen}
                                        onChange={() => toggleGroup(a.group)}
                                    />
                                </div>
                                <label className="form-label mt-0 mb-0" htmlFor={`toggle-${a.group}`}>
                                    {a.group}
                                </label>
                            </div>
                            {isOpen && (
                                <div className="ps-4 pt-2">
                                    {a.options.map((b) => (
                                        <div className="form-check" key={b.layer_id}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                value={b.layer_id}
                                                name="p4layer"
                                                id={`p4layer${b.layer_id}`}
                                                checked={selectedLayerId == b.layer_id}
                                                onChange={(e) => {
                                                    handleLayerChange(e);
                                                    setOpenGroup(a.group);
                                                }}
                                                disabled={!b.status}
                                            />
                                            <label className="form-check-label" htmlFor={`p4layer${b.layer_id}`}>
                                                {b.label}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </>
    );
};

function Dashboard(props) {
    const apiUrl = envConfig.API_URL;
    const apiPayload = { method: "POST", headers: { "Content-Type": "application/json" } };
    const uqArray = (arr) => [...new Set(arr)];
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedProduct, setSelectedProduct, isFromUI, setIsFromUI } = useSelectedProduct();
    // State variables
    const [height, setHeight] = useState(window.innerHeight);
    const [activeTab, setActiveTab] = useState(1);
    const [currentTab, setCurrentTab] = useState("layer");
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(0);
    const [lookUpLoading, setLookUpLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(true);
    const [selectedHazard, setSelectedHazard] = useState("flood");
    const [dataSrcList, setDataSrcList] = useState([]);
    const [selectedDataSrcId, setSelectedDataSrcId] = useState(1);
    const [allLayerOptions, setAllLayerOptions] = useState([]);
    const [layerOptions, setLayerOptions] = useState([]);
    const [groupLayerOptions, setGroupLayerOptions] = useState([]);
    const [selectedLayerId, setSelectedLayerId] = useState(2);
    const [selectedTimescale, setSelectedTimescale] = useState("longterm");
    const getYears = (from, to) => Array.from({ length: to - from + 1 }, (_, i) => from + i).sort((a, b) => (a > b ? -1 : 0));
    const [showYearSlider, setShowYearSlider] = useState(false);
    const [showYearFilter, setShowYearFilter] = useState(false);
    const [showMonthFilter, setShowMonthFilter] = useState(false);
    const [showP8dayFilter, setShowP8DayFilter] = useState(false);
    const [yearOptions, setYearOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [p8DayOptions, setp8DayOptions] = useState([]);
    const [selectedYear, setSelectedYear] = useState({ value: 2024, label: 2024 });
    const [selectedMonth, setSelectedMonth] = useState({ value: 12, label: "December" });
    const [selectedP8Day, setSelectedP8Day] = useState({ value: 20240101, label: "Jan 1 to Jan 8" });
    const [selectedAdmX, setSelectedAdmX] = useState(2);
    const [geojsonCountry, setGeojsonCountry] = useState(null);
    const [geojsonProvince, setGeojsonProvince] = useState(null);
    const [geojsonDistrict, setGeojsonDistrict] = useState(null);
    const [geojsonData, setGeojsonData] = useState(null);
    const [countries, setCountries] = useState([]);
    const [sentinelCountries, setSentinelCountries] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({ value: "", label: "All Countries" });
    const [provinces, setProvinces] = useState([]);
    const [provinceOptions, setProvinceOptions] = useState([]);
    const [isProvinceFilterDisabled, setIsProvinceFilterDisabled] = useState(true);
    const [selectedProvince, setSelectedProvince] = useState({ value: "", label: "Choose a country first" });
    const [districts, setDistricts] = useState([]);
    const [mapRefreshKey, setMapRefreshKey] = useState(0);
    const [mapView, setMapView] = useState("Raster");
    const [vectorData, setVectorData] = useState({});
    const [rasterData, setRasterData] = useState({});

    // Sync product selection with URL
    useEffect(() => {
        const path = location.pathname;
        const productMatch = path.match(/^\/(product[1-4])\/dashboard$/);
        const newProduct = productMatch ? productMatch[1] : "product4";

        if (newProduct !== selectedProduct && !isFromUI) {
            console.log(`URL Sync: Setting product to ${newProduct} from URL ${path}`);
            setSelectedProduct(newProduct);
            setActiveTab(1);
            setCurrentTab("layer");
        }
    }, [location.pathname, selectedProduct, setSelectedProduct, isFromUI, setIsFromUI]);

    // Handle product selection
    const handleProductSelect = (product) => {
        console.log(`Dropdown: Changing product to ${product}`);
        setIsFromUI(true);
        setSelectedProduct(product);
        setActiveTab(1);
        setCurrentTab("layer");
        navigate(`/${product}/dashboard`, { replace: false });
        setTimeout(() => setIsFromUI(false), 0);
    };

    // Handle window resize
    useEffect(() => {
        const handleResize = () => setHeight(window.innerHeight);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Other-page/links related functions
    const handleTabClick = (currentTab) => {
        if (loading) return;
        if (currentTab !== activeTab) {
            setActiveTab(currentTab);
            if (currentTab === 4 || currentTab === 5) {
                setCurrentTab(null);
            } else {
                setCurrentTab("layer");
            }
        }
    };

    // Main window, side-nav toggle display
    const toggleSidenav = () => setIsOpen(!isOpen);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSliderValueChange = (value) => {
        setSelectedYear(value);
        getLayerData(); // Trigger data fetch on year change
    };

    // Loader component for lookup data
    const LookUpLoader = () => (
        <div>
            <div className="spinner-border text-primary" role="status" style={{ width: "1rem", height: "1rem" }}>
                <span className="sr-only"></span>
            </div>
        </div>
    );

    // Initial onmount data
    const onMount1 = () => {
        setLookUpLoading(true);
        setLoading((prev) => prev + 1);
        let reqBodyTimescale = {
            ...apiPayload,
            body: JSON.stringify({ year: selectedYear?.value || 2024 })
        };
        Promise.all([
            fetch(`/data/p2/adm0_p2.geojson`).then((response) => response.json()),
            fetch(`/data/p2/adm1_p2.geojson`).then((response) => response.json()),
            fetch(`/data/p2/adm2_p2.geojson`).then((response) => response.json()),
            fetch(`${apiUrl}/lookups/p4_ds`, apiPayload).then((response) => response.json()),
            fetch(`${apiUrl}/lookups/p4_layers`, apiPayload).then((response) => response.json()),
            fetch(`${apiUrl}/lookups/p4_f2_adm0`, apiPayload).then((response) => response.json()),
            fetch(`${apiUrl}/lookups/p4_month`, reqBodyTimescale).then((response) => response.json()),
            fetch(`${apiUrl}/lookups/p4_8day`, reqBodyTimescale).then((response) => response.json()),
        ])
            .then((responses) => {
                let [
                    geoJsonContent0,
                    geoJsonContent1,
                    geoJsonContent2,
                    lkpDataSrc,
                    lkpP4LayerList,
                    lkpSentinelAdm0,
                    lkpMonth,
                    lkpP8Day,
                ] = responses;
                setGeojsonCountry(geoJsonContent0);
                setGeojsonData(geoJsonContent0);
                setGeojsonProvince(geoJsonContent1);
                setGeojsonDistrict(geoJsonContent2);
                setDataSrcList(lkpDataSrc.data);
                setAllLayerOptions(lkpP4LayerList.data);
                fillLayerOptions(lkpP4LayerList.data, 1);
                saveAllCountries(geoJsonContent0, lkpSentinelAdm0.data);
                saveAllProvinces(geoJsonContent1);
                saveAllDistricts(geoJsonContent2);
                let years = getYears(2001, 2024);
                setYearOptions(years.map((a) => ({ value: a, label: a })));
                let months = lkpMonth.data.sort((a, b) => (a.value > b.value ? -1 : 0));
                setMonthOptions(months);
                let p8days = lkpP8Day.data.sort((a, b) => (a.value > b.value ? -1 : 0));
                setp8DayOptions(p8days);
                // Fetch initial data after lookups are loaded
                getLayerData();
            })
            .catch((err) => {
                console.error("Failed to fetch initial data", err);
            })
            .finally(() => {
                setLookUpLoading(false);
                setLoading((prev) => (prev > 0 ? prev - 1 : 0));
            });
    };
    useEffect(() => onMount1(), []);

    const handleHazardChange = (e) => {
        let hazard = e.target.value;
        setSelectedHazard(hazard);
        let years;
        if (hazard === "flood") {
            setSelectedDataSrcId(1);
            fillLayerOptions(allLayerOptions, 1);
            setCountryOptions(countries);
            years = getYears(2001, 2024);
            setSelectedYear({ value: 2024, label: 2024 });
        } else if (hazard == "drought") {
            setSelectedDataSrcId(3);
            fillLayerOptions(allLayerOptions, 3);
            setCountryOptions(countries);
            years = getYears(2001, 2021);
            setSelectedYear({ value: 2021, label: 2021 });
        }
        setYearOptions(years.map((a) => ({ value: a, label: a })));
        // No getLayerData call here
    };

    const handleDataSrcChange = (e) => {
        let dataSrcId = Number(e.target.value);
        setSelectedDataSrcId(dataSrcId);
        fillLayerOptions(allLayerOptions, dataSrcId);
        let years;
        switch (true) {
            case dataSrcId === 1:
                setCountryOptions(countries);
                years = getYears(2001, 2024);
                setSelectedYear({ value: 2024, label: 2024 });
                break;
            case dataSrcId === 2:
                setSelectedCountry({ value: "", label: "All countries" });
                setProvinceOptions([]);
                setIsProvinceFilterDisabled(true);
                setCountryOptions(sentinelCountries);
                setSelectedCountry(sentinelCountries.filter((a) => a.label == "Nigeria")[0]);
                handleCountryChange(sentinelCountries.filter((a) => a.label == "Nigeria")[0]);
                setIsProvinceFilterDisabled(false);
                years = getYears(2018, 2024);
                setSelectedYear({ value: 2024, label: 2024 });
                break;
            case dataSrcId === 3:
                setCountryOptions(countries);
                years = getYears(2001, 2021);
                setSelectedYear({ value: 2021, label: 2021 });
                break;
            default:
                break;
        }
        setYearOptions(years.map((a) => ({ value: a, label: a })));
        // No getLayerData call here
    };

    const fillLayerOptions = (fullLayerList, dataSrcId) => {
        if (!fullLayerList || fullLayerList.length === 0) return;
        let filteredLayerList = fullLayerList.filter((a) => a.data_source_id === dataSrcId);
        setLayerOptions(filteredLayerList);
        let uqGroups = [...new Set(filteredLayerList.map((a) => a.group))];
        let groupedOptions = uqGroups.map((a) => {
            let filteredUnderGroup = filteredLayerList.filter((b) => b.group === a);
            return {
                group: a,
                options: filteredUnderGroup.map((b) => {
                    return { layer_id: b.layer_id, label: b.label, info: `${b.dataset_type}: ${b.dataset_info}`, status: b.status };
                })
            };
        });
        setGroupLayerOptions(groupedOptions);
        const defaultLayer = filteredLayerList.filter((a) => a.status)[0];
        if (defaultLayer) {
            setSelectedLayerId(defaultLayer.layer_id);
            setSelectedTimescale(defaultLayer.timescale);
            toggleTimescaleSelection(defaultLayer.timescale);
        }
    };

    const handleLayerChange = (e) => {
        let layerId = Number(e.target.value);
        setSelectedLayerId(layerId);
        let timescale = layerOptions.find((b) => b.layer_id === layerId).timescale;
        setSelectedTimescale(timescale);
        toggleTimescaleSelection(timescale);
        // No getLayerData call here
    };

    const toggleTimescaleSelection = (timescale) => {
        switch (timescale) {
            case "longterm":
                setShowYearSlider(false);
                setShowYearFilter(false);
                setShowMonthFilter(false);
                setShowP8DayFilter(false);
                break;
            case "annual":
                setShowYearSlider(true);
                setShowYearFilter(true);
                setShowMonthFilter(false);
                setShowP8DayFilter(false);
                break;
            case "monthly":
                setShowYearSlider(false);
                setShowYearFilter(true);
                setShowMonthFilter(true);
                setShowP8DayFilter(false);
                break;
            case "8day":
                setShowYearSlider(false);
                setShowYearFilter(true);
                setShowMonthFilter(false);
                setShowP8DayFilter(true);
                break;
            default:
                break;
        }
    };

    const handleMonthChange = (selectedOption) => {
        setSelectedMonth(selectedOption);
        // No getLayerData call here
    };

    const handleP8DayChange = (selectedOption) => {
        setSelectedP8Day(selectedOption);
        // No getLayerData call here
    };

    const handleYearChange = (selectedOption) => {
        setSelectedYear(selectedOption);
        getSubYearOptions(selectedOption.value);
        // No getLayerData call here
    };

    const getSubYearOptions = (year) => {
        setLoading((prev) => prev + 1);
        let reqBodyTimescale = { ...apiPayload, body: JSON.stringify({ year }) };
        Promise.all([
            fetch(`${apiUrl}/lookups/p4_month`, reqBodyTimescale).then((response) => response.json()),
            fetch(`${apiUrl}/lookups/p4_8day`, reqBodyTimescale).then((response) => response.json()),
        ])
            .then((responses) => {
                let [lkpMonths, lkp8DayPeriods] = responses;
                let apiAllSuccess = responses.map((a) => a.success).every(Boolean);
                if (apiAllSuccess) {
                    setMonthOptions(lkpMonths.data);
                    setp8DayOptions(lkp8DayPeriods.data);
                } else {
                    let errMessage = responses.filter((a) => !a.success).map((a) => a.message).join("\n");
                    console.error(errMessage);
                }
            })
            .finally(() => {
                setLoading((prev) => (prev > 0 ? prev - 1 : 0));
            });
    };

    const handleAdmXChange = (e) => {
        let admX = Number(e.target.value);
        setSelectedAdmX(admX);
        switch (admX) {
            case 0:
                setGeojsonData(geojsonCountry);
                break;
            case 1:
                setGeojsonData(geojsonProvince);
                break;
            case 2:
                setGeojsonData(geojsonDistrict);
                break;
            default:
                break;
        }
        // No getLayerData call here
    };

    const saveAllCountries = (geoJsonContent0, lkpSentinelAdm0Data) => {
        let countries = [];
        if (geoJsonContent0 && geoJsonContent0.features && Array.isArray(geoJsonContent0.features)) {
            countries = geoJsonContent0.features.map((a) => a.properties).map((a) => ({
                value: a.ADM0_CODE,
                label: a.ADM0_NAME
            }));
            countries.sort((a, b) => (a.label > b.label ? 1 : -1));
        } else {
            console.warn("geoJsonContent0.features is undefined or not an array:", geoJsonContent0);
        }
        setCountries(countries);
        let sentinelCountries = lkpSentinelAdm0Data.map((a) => ({
            value: a.ADM0_CODE,
            label: a.ADM0_NAME
        }));
        sentinelCountries.sort((a, b) => (a.label > b.label ? 1 : -1));
        setSentinelCountries(sentinelCountries);
        setCountryOptions(countries);
    };

    const saveAllProvinces = (geoJsonContent1) => {
        let provinces = [];
        if (geoJsonContent1 && geoJsonContent1.features && Array.isArray(geoJsonContent1.features)) {
            provinces = geoJsonContent1.features.map((a) => a.properties).map((a) => ({
                value: a.ADM1_CODE,
                label: a.ADM1_NAME,
                ADM0_CODE: a.ADM0_CODE
            }));
            provinces.sort((a, b) => (a.label > b.label ? 1 : -1));
        } else {
            console.warn("geoJsonContent1.features is undefined or not an array:", geoJsonContent1);
        }
        setProvinces(provinces);
    };

    const saveAllDistricts = (geoJsonContent2) => {
        let districts = [];
        if (geoJsonContent2 && geoJsonContent2.features && Array.isArray(geoJsonContent2.features)) {
            districts = geoJsonContent2.features.map((a) => a.properties).map((a) => ({
                value: a.ADM2_CODE,
                label: a.ADM2_NAME,
                ADM1_CODE: a.ADM1_CODE,
                ADM2_NAME: a.ADM2_NAME
            }));
            districts.sort((a, b) => (a.label > b.label ? 1 : -1));
        } else {
            console.warn("geoJsonContent2.features is undefined or not an array:", geoJsonContent2);
        }
        setDistricts(districts);
    };

    const handleCountryChange = (selectedOption) => {
        setSelectedCountry(selectedOption);
        if (selectedOption.value) {
            let provincesForCountry = provinces.filter((a) => a.ADM0_CODE == selectedOption.value);
            setProvinceOptions(provincesForCountry);
            setSelectedProvince({ value: "", label: `All Provinces (${selectedOption.label})` });
            setIsProvinceFilterDisabled(false);
        } else {
            setProvinceOptions([]);
            setSelectedProvince({ value: "", label: "Choose a country first" });
            setIsProvinceFilterDisabled(true);
        }
        // No getLayerData call here
    };

    const handleProvinceChange = (selectedOption) => {
        setSelectedProvince(selectedOption);
        // No getLayerData call here
    };

    const getLayerData = () => {
        return new Promise((resolve, reject) => {
            let reqBody = {
                ...apiPayload,
                body: JSON.stringify({
                    layer_id: selectedLayerId,
                    ts_year: selectedTimescale !== "longterm" ? selectedYear.value : null,
                    ts_month: selectedTimescale === "monthly" ? selectedMonth.value : null,
                    ts_8day: selectedTimescale === "8day" ? selectedP8Day.value : null,
                    admX: selectedAdmX,
                    adm0_code: selectedCountry.value ? [selectedCountry.value] : [],
                    adm1_code: selectedProvince.value ? [selectedProvince.value] : [],
                })
            };
            setLoading((prev) => prev + 1);
            fetch(`${apiUrl}/p4/data`, reqBody)
                .then((response) => response.json())
                .then((response) => {
                    setMapView(response.data.map_view);
                    if (response.data.map_view === "Vector") {
                        setVectorData(response.data);
                        setRasterData(null);
                    } else if (response.data.map_view === "Raster") {
                        setVectorData(null);
                        setRasterData(response.data);
                    }
                    setMapRefreshKey((prev) => prev + 1);
                    resolve();
                })
                .catch((err) => {
                    console.error("Failed to fetch filtered data", err);
                    reject(err);
                })
                .finally(() => {
                    setLoading((prev) => (prev > 0 ? prev - 1 : 0));
                });
        });
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top p-1">
                <div className="container-fluid px-0">
                    <Link className="navbar-brand" to="/">
                        <img loading="lazy" src="/assets/images/logo.svg" alt="Logo" />
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarText"
                        aria-controls="navbarText"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse pl-52px d-flex justify-content-between align-items-center" id="navbarText">
                        <div className="d-flex justify-content-center flex-grow-1">
                            <div className="d-flex align-items-center">
                                <h5 style={{ margin: "0" }}>
                                    {({
                                        product1: "Multi Hazard Mapping",
                                        product2: "Vulnerability and Risk Analysis",
                                        product3: "Flood Forecasting and Early Warning",
                                        product4: "Flood and Drought Monitor"
                                    })[selectedProduct] || "Flood and Drought Monitor"}
                                </h5>
                                <Link
                                    to="#"
                                    onClick={() => {
                                        handleShow();
                                    }}
                                    className={activeTab === 2 ? "btn btn-contact me-1" : "nav-link ms-3"}
                                    style={activeTab === 2 ? { width: "60px" } : {}}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Switch Product"
                                >
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M3 7H19M19 7L15 3M19 7L15 11M19 15H3M3 15L7 11M3 15L7 19"
                                            stroke={activeTab === 2 ? "white" : "black"}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                            </div>
                        </div>
                        <ul className="navbar-nav d-flex flex-row align-items-center">
                            <li className="nav-item me-2">
                                <Link
                                    to="#"
                                    className={activeTab === 1 ? "btn btn-contact me-1" : `nav-link${loading ? " disabled" : ""}`}
                                    style={activeTab === 1 ? { width: "60px" } : {}}
                                    onClick={() => setActiveTab(1)}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Layers"
                                >
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M1.8335 15.5833L11.0002 20.1667L20.1668 15.5833M1.8335 11L11.0002 15.5833L20.1668 11M11.0002 1.83334L1.8335 6.41668L11.0002 11L20.1668 6.41668L11.0002 1.83334Z"
                                            stroke={activeTab === 1 ? "white" : "black"}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                            </li>
                            <li className="nav-item me-2">
                                <Link
                                    to="#"
                                    className={activeTab === 4 ? "btn btn-contact me-1" : `nav-link${loading ? " disabled" : ""}`}
                                    style={activeTab === 4 ? { width: "60px" } : {}}
                                    onClick={() => !loading && setActiveTab(4)}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Help/Info"
                                >
                                    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M8.83266 8.25001C9.04817 7.63737 9.47355 7.12077 10.0335 6.79172C10.5934 6.46266 11.2517 6.34237 11.8917 6.45216C12.5318 6.56196 13.1124 6.89474 13.5306 7.39158C13.9489 7.88841 14.1778 8.51724 14.1768 9.16668C14.1768 11 11.4268 11.9167 11.4268 11.9167M11.5002 15.5833H11.5093M20.6668 11C20.6668 16.0626 16.5628 20.1667 11.5002 20.1667C6.43755 20.1667 2.3335 16.0626 2.3335 11C2.3335 5.9374 6.43755 1.83334 11.5002 1.83334C16.5628 1.83334 20.6668 5.9374 20.6668 11Z"
                                            stroke={activeTab === 4 ? "white" : "black"}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                            </li>
                            <li className="nav-item me-2">
                                <Link
                                    to="#"
                                    className={activeTab === 5 ? "btn btn-contact me-1" : `nav-link${loading ? " disabled" : ""}`}
                                    style={activeTab === 5 ? { width: "60px" } : {}}
                                    onClick={() => !loading && setActiveTab(5)}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Export/Download"
                                >
                                    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M19.75 13.75V17.4167C19.75 17.9029 19.5568 18.3692 19.213 18.713C18.8692 19.0568 18.4029 19.25 17.9167 19.25H5.08333C4.5971 19.25 4.13079 19.0568 3.78697 18.713C3.44315 18.3692 3.25 17.9029 3.25 17.4167V13.75M6.91667 9.16667L11.5 13.75M11.5 13.75L16.0833 9.16667M11.5 13.75V2.75"
                                            stroke={activeTab === 5 ? "white" : "black"}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="btn btn-contact me-1"
                                    to="/"
                                    style={{ width: "60px" }}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Home"
                                >
                                    <i className="bi bi-house fs-6"></i>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <div className="tab-content" id="myTabContent" style={{ height: "100%" }}>
                <div className="help-info-container" style={{ display: activeTab === 4 ? "block" : "none" }}>
                    <DashboardHelpInfoTab key="help-info" />
                </div>
                <div className="export-download-container" style={{ display: activeTab === 5 ? "block" : "none" }}>
                    <DashboardExportTab key="export-download" />
                </div>
                <div
                    className={`tab-pane ${currentTab === "layer" ? "show active" : ""}`}
                    id="layer"
                    role="tabpanel"
                    aria-labelledby="layer-tab"
                    style={{ display: activeTab === 1 && currentTab === "layer" ? "block" : "none" }}
                >
                    <div className="container-fluid d-flex px-0">
                        <div className={`sidenav p4 ${isOpen ? "open" : "collapsed"}`}>
                            <button
                                className="toggle-btn newBtn"
                                onClick={toggleSidenav}
                                style={{ left: isOpen && selectedHazard === "flood" ? "342px" : isOpen && selectedHazard === "drought" ? "291px" : "54px" }}
                            >
                                <img
                                    loading="lazy"
                                    src={isOpen ? "../assets/images/Layout.png" : "../assets/images/LayoutWhite.svg"}
                                    alt="Toggle Sidenav"
                                    className="toggle-icon"
                                />
                            </button>
                            {isOpen ? (
                                <div className="card border-0" style={{ marginTop: "22px", overflowY: "auto", overflowX: "hidden", scrollbarWidth: "none" }}>
                                    <div className="card-body p-0">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-12 px-1">
                                                <div className="accordian-filter">
                                                    <Accordion defaultActiveKey={["0"]} alwaysOpen>
                                                        <Accordion.Item eventKey="0">
                                                            <Accordion.Body className="pt-0 p-2">
                                                                <div className="row">
                                                                    <div className="col-sm-12 col-md-12 col-lg-12">
                                                                        {/* Hazard Selection */}
                                                                        <div className="form-label">
                                                                            <label>Hazard</label>
                                                                        </div>
                                                                        {lookUpLoading ? <LookUpLoader /> : (
                                                                            <div className="form-group d-flex gap-3 pb-2">
                                                                                <div className="form-check">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="radio"
                                                                                        value="flood"
                                                                                        name="p4hazard"
                                                                                        id="p4flood"
                                                                                        checked={selectedHazard === "flood"}
                                                                                        onChange={handleHazardChange}
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor="p4flood">
                                                                                        Flood
                                                                                    </label>
                                                                                </div>
                                                                                <div className="form-check">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="radio"
                                                                                        value="drought"
                                                                                        name="p4hazard"
                                                                                        id="p4drought"
                                                                                        checked={selectedHazard === "drought"}
                                                                                        onChange={handleHazardChange}
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor="p4drought">
                                                                                        Drought
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/* Data source selection */}
                                                                        <div className="form-label">
                                                                            <label>Data Source</label>
                                                                        </div>
                                                                        {lookUpLoading ? <LookUpLoader /> : (
                                                                            <div className="form-group d-flex gap-2 flex-wrap border-bottom border-0 pb-2">
                                                                                {dataSrcList.filter((a) => a.hazard == selectedHazard).map((a) => (
                                                                                    <div className="form-check" key={a.data_source_id}>
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            value={a.data_source_id}
                                                                                            name="p4datasrc"
                                                                                            id={`p4datasrc${a.data_source_id}`}
                                                                                            disabled={!a.status}
                                                                                            checked={selectedDataSrcId === a.data_source_id}
                                                                                            onChange={handleDataSrcChange}
                                                                                        />
                                                                                        <label className="form-check-label" htmlFor={`p4datasrc${a.data_source_id}`}>
                                                                                            {a.label}&nbsp;
                                                                                        </label>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                        {/* Administrative boundaries - admX selection */}
                                                                        <div className="form-label">
                                                                            <label>Administrative Boundaries</label>
                                                                        </div>
                                                                        {lookUpLoading ? <LookUpLoader /> : (
                                                                            <div className="form-group d-flex gap-3">
                                                                                <div className="form-check">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="radio"
                                                                                        value={0}
                                                                                        name="p4admx"
                                                                                        id="p4adm0"
                                                                                        checked={selectedAdmX === 0}
                                                                                        onChange={handleAdmXChange}
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor="p4adm0">
                                                                                        Countries
                                                                                    </label>
                                                                                </div>
                                                                                <div className="form-check">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="radio"
                                                                                        value={1}
                                                                                        name="p4admx"
                                                                                        id="p4adm1"
                                                                                        checked={selectedAdmX === 1}
                                                                                        onChange={handleAdmXChange}
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor="p4adm1">
                                                                                        Provinces
                                                                                    </label>
                                                                                </div>
                                                                                <div className="form-check">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="radio"
                                                                                        value={2}
                                                                                        name="p4admx"
                                                                                        id="p4adm2"
                                                                                        checked={selectedAdmX === 2}
                                                                                        onChange={handleAdmXChange}
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor="p4adm2">
                                                                                        Districts
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/* Location selection - country/province */}
                                                                        <div className="row my-2 border-bottom border-1 pb-2">
                                                                            <div className="col-sm-12 col-md-12 col-lg-12">
                                                                                <div className="form-group">
                                                                                    <label className="form-label">Country</label>
                                                                                    {lookUpLoading ? <LookUpLoader /> : (
                                                                                        countryOptions.length && (
                                                                                            <Select
                                                                                                options={
                                                                                                    selectedDataSrcId !== 2
                                                                                                        ? [{ value: "", label: "All countries" }, ...countryOptions]
                                                                                                        : countryOptions
                                                                                                }
                                                                                                isSearchable
                                                                                                value={selectedCountry}
                                                                                                onChange={handleCountryChange}
                                                                                                className="countrySelect"
                                                                                                placeholder="Select a country"
                                                                                                formatOptionLabel={({ value, label }) => (value === "" ? "All countries" : label)}
                                                                                            />
                                                                                        )
                                                                                    )}
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <label className="form-label">Province</label>
                                                                                    {lookUpLoading ? <LookUpLoader /> : (
                                                                                        <Select
                                                                                            options={
                                                                                                selectedCountry.value && provinceOptions.length
                                                                                                    ? [
                                                                                                        { value: "", label: `All Provinces (${selectedCountry.label})` },
                                                                                                        ...provinceOptions
                                                                                                    ]
                                                                                                    : [{ value: "", label: "Choose a country first" }]
                                                                                            }
                                                                                            isDisabled={isProvinceFilterDisabled}
                                                                                            value={selectedProvince}
                                                                                            onChange={handleProvinceChange}
                                                                                            className="provinceSelect"
                                                                                            placeholder={selectedCountry.value ? `Select a province (${selectedCountry.label})` : "Choose a country first"}
                                                                                            formatOptionLabel={({ value, label }) =>
                                                                                                value === "" && selectedCountry.value ? `All provinces selected (${selectedCountry.label})` : label
                                                                                            }
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/* Layer option selection */}
                                                                        {lookUpLoading ? <LookUpLoader /> : (
                                                                            <LayerGroupSelector
                                                                                groupLayerOptions={groupLayerOptions}
                                                                                layerOptions={layerOptions}
                                                                                selectedLayerId={selectedLayerId}
                                                                                handleLayerChange={handleLayerChange}
                                                                            />
                                                                        )}
                                                                        {/* Alternating time period selections - year/month/8day-period */}
                                                                        <div className="row my-2 border-bottom border-1 pb-2">
                                                                            {showYearFilter && (
                                                                                <div className="form-group">
                                                                                    <label>Year</label>
                                                                                    {lookUpLoading ? <LookUpLoader /> : (
                                                                                        yearOptions.length && (
                                                                                            <Select
                                                                                                options={yearOptions}
                                                                                                value={selectedYear}
                                                                                                onChange={handleYearChange}
                                                                                            />
                                                                                        )
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                            {showMonthFilter && (
                                                                                <div className="form-group">
                                                                                    <label>Month</label>
                                                                                    {lookUpLoading ? <LookUpLoader /> : (
                                                                                        monthOptions.length && (
                                                                                            <Select
                                                                                                options={monthOptions}
                                                                                                value={selectedMonth}
                                                                                                onChange={handleMonthChange}
                                                                                            />
                                                                                        )
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                            {showP8dayFilter && (
                                                                                <div className="form-group">
                                                                                    <label>8 day period</label>
                                                                                    {lookUpLoading ? <LookUpLoader /> : (
                                                                                        p8DayOptions.length && (
                                                                                            <Select
                                                                                                options={p8DayOptions}
                                                                                                value={selectedP8Day}
                                                                                                onChange={handleP8DayChange}
                                                                                            />
                                                                                        )
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        {/* Apply button */}
                                                                        {lookUpLoading ? <LookUpLoader /> : (
                                                                            <div className="d-flex justify-content-between">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-apply w-100 mt-2"
                                                                                    onClick={getLayerData}
                                                                                    disabled={loading}
                                                                                >
                                                                                    {loading ? "Wait..." : "Apply"}
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    </Accordion>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <img loading="lazy" src="../assets/images/filters.svg" alt="Collapsed Icon" className="collapsed-icon mt-5" />
                            )}
                        </div>

                        {mapView && geojsonData && (
                            <Product2Map
                                mapRefreshKey={mapRefreshKey}
                                selectedHazard={selectedHazard}
                                mapView={mapView}
                                admX={selectedAdmX}
                                geojsonAdmX={geojsonData}
                                geojsonMaster={geojsonDistrict}
                                adm0Code={selectedCountry?.value || null}
                                adm1Code={selectedProvince?.value || null}
                                vectorData={vectorData}
                                rasterData={rasterData}
                                sideBarOpen={isOpen}
                                onSliderChange={handleSliderValueChange}
                                showYearSlider={showYearSlider}
                                years={yearOptions}
                                selectedYear={selectedYear}
                                onMapUpdateComplete={() => Promise.resolve()}
                            />
                        )}
                    </div>
                </div>
            </div>

            <div className="App">
                <SwitchProducts show={show} handleClose={handleClose} />
            </div>
        </>
    );
}

export default Dashboard;